import classNames from 'classnames/bind';
import TopInfoBox from 'common/modal/chart/oversea/info';
import { useState } from 'react';
import List, { SortType } from './List';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

const RecommendedSchedule = () => {
  const [sortOrder, setSortOrder] = useState(SortType.fareDesc);
  return (
    <div className={cx('recommend')}>
      <TopInfoBox position="rcd" />
      <div className={cx('content')}>
        <div className={cx('filter')}>
          <div className={cx('sort')}>
            <button
              type="button"
              className={cx('option')}
              role="button"
              aria-selected={sortOrder === SortType.fareDesc}
              data-event-nlog="click"
              data-event-area-code="rcd.price"
              onClick={() => setSortOrder(SortType.fareDesc)}
            >
              최저가순
            </button>
            <button
              type="button"
              className={cx('option')}
              role="button"
              aria-selected={sortOrder === SortType.sdateDesc}
              data-event-nlog="click"
              data-event-area-code="rcd.sdate"
              onClick={() => setSortOrder(SortType.sdateDesc)}
            >
              출발일순
            </button>
          </div>
        </div>
        <List sortOrder={sortOrder} />
      </div>
    </div>
  );
};

export default RecommendedSchedule;
